import * as React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import { appAction } from "../../actions/app.action";
import { portfolioAction } from "../../actions/portfolio.action";
import Button from "@material-ui/core/Button/Button";
import { userAction } from "../../actions/user.action";
import SectionHeader from "../../components/UI/SectionHeader";
import { householdAction } from "../../actions/household.action";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    paddingBottom: theme.wbiComponent.educationComponent.height + 10,
  },
  contentCaption: {
    marginBottom: 10,
  },
  videoWrapper: {
    width: "100%",
    position: "relative",
    paddingBottom: "45%",
    height: "0",
  },
  video: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
  },
  ctaWrapper: {
    marginTop: 10,
    marginRight: 120,
    float: "right",
    [theme.breakpoints.down("md")]: {
      float: "none",
      marginRight: 54,
      textAlign: "right",
    },
  },
  ctaWrapperLeft: {
    marginTop: 10,
    marginLeft: 125,
    float: "left",
  },
});

class Education extends React.Component {
  state = {
    timer: 59,
  };

  videoWatched = () => {
    this.props.dispatch(userAction.videoWatched());
  };

  startCountdown = () => {
    this.interval = setInterval(() => {
      if (this.state.timer > 0) {
        this.setState({ timer: this.state.timer - 1 });
      }
    }, 1000);
  };

  stopCountdown = () => {
    clearInterval(this.interval);
  };

  componentDidMount() {
    this.props.dispatch(portfolioAction.clearCurrentPortfolio());
    this.props.dispatch(householdAction.clearCurrentHousehold());
    this.props.dispatch(appAction.setPortfolioNav());
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setEducationNav(true));
    this.startCountdown();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.timer === 0) {
      this.stopCountdown();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.user.user.hasOwnProperty("video_watched") &&
      !this.props.user.user.video_watched &&
      nextProps.user.user.video_watched
    ) {
      this.props.history.push("/Portal/dashboard");
    }
  }

  componentWillUnmount() {
    this.stopCountdown();
    this.props.dispatch(appAction.setEducationNav(false));
  }

  render() {
    const { user, classes, app } = this.props;
    const { timer } = this.state;
    const videoSrc =
      app.educationVideoPath +
      (!app.useVideoGate || user.user.video_watched ? "" : "&autoplay=1");
    if (!user.user.hasOwnProperty("video_watched")) {
      return null;
    }

    return (
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <SectionHeader text={"Education"} />
          <div className={classes.videoWrapper}>
            <iframe
              className={classes.video}
              title="Education Video"
              src={videoSrc}
              width="680"
              height="360"
              frameBorder="0"
              allow="autoplay"
              allowFullScreen
            />
          </div>
          {app.useVideoGate && (
            <div className={classes.ctaWrapper}>
              {user.user.video_watched ?
                null: (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={timer !== 0}
                  onClick={this.videoWatched}
                >
                  {timer !== 0
                    ? `Demo Cy in ` + timer + " Seconds"
                    : "Start"}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

Education.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
    appName: state.app.appName,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(Education)
);



// WEBPACK FOOTER //
// ./src/containers/Education/index.jsx